import { ApolloClient, InMemoryCache } from "@apollo/client";
// import { PUT_IMAGE_EVENT_MUTATION } from ".n";
import {
  GET_PRESIGNED_URLS_QUERY,
  GET_TAGGED_MEDIA_QUERY,
  GET_PRESIGNED_GET_URLS_QUERY,
} from "../graphql/imageQuery"; // Corrected path

const GRAPHQL_ENDPOINT =
  "https://g4hngea4jff63nikf5afadahlu.appsync-api.us-east-1.amazonaws.com/graphql";

const client = new ApolloClient({
  uri: GRAPHQL_ENDPOINT,
  cache: new InMemoryCache(),
  headers: {
    "x-api-key": "da2-ofsckugubrhb3gn6rjqlzxanni",
  },
});

export const getTaggedMediaFromApi = async (tagSet) => {
  console.log(`PMM - SF - api - fetchTaggedMediaFromApi initiated`);
  console.log(
    `PMM - SF - api - fetchTaggedMediaFromApi - fetching tagged media for tagSet: ${JSON.stringify(
      tagSet
    )}`
  );

  try {
    const apiPayload = {
      query: GET_TAGGED_MEDIA_QUERY,
      variables: {
        input: {
          operationType: "GET_TAGGED_MEDIA",
          entityType: "IMAGE",
          tags: tagSet,
        },
      },
    };
    console.log(
      `PMM - SF - api - getTaggedMediaFromApi - apiPayload: ${JSON.stringify(
        apiPayload
      )}`
    );
    console.log(
      `PMM - SF - api - getTaggedMediaFromApi - just before client.query(apiPayload)`
    );
    const response = await client.query(apiPayload);
    console.log(
      `PMM - SF - api - getTaggedMediaFromApi - just after client.query(apiPayload)`
    );
    console.log(
      `PMM - SF - imageApi.js - getTaggedMediaFromApi - response is: ${JSON.stringify(
        response
      )}`
    );
    const libraryCards = response.data.getTaggedMedia.libraryCards;
    console.log(
      `PMM - SF - imageApi.js - getTaggedMediaFromApi - response is: ${JSON.stringify(
        response
      )}`
    );

    return libraryCards;
  } catch (error) {
    console.log(`PMM - SF - catch hit! - error is: ${JSON.stringify(error)}`);
  }
};

// export const putImagesToApi = async ({ operationType, entityType, key3 }) => {
//   try {
//     const apiPayload = {
//       mutation: PUT_IMAGE_EVENT_MUTATION,
//       variables: { operationType, entityType, key3 },
//     };
//     const mutationReturnResult = await client.mutate(apiPayload);
//     // const mutationReturnResult = await client.mutate({
//     //   mutation: PUT_IMAGE_EVENT_MUTATION,
//     //   variables: { operationType, entityType, key3 },
//     // });
//     return mutationReturnResult.data;
//   } catch (error) {
//     console.error("Error putting images:", error);
//     throw error;
//   }
// };

export const fetchPresignedUrlsFromApi = async (fileNames) => {
  console.log(
    `PMM - SF - api - fetchPresignedUrlsFromApi - fetching URLs for fileNames: ${JSON.stringify(
      fileNames
    )}`
  );

  try {
    const apiPayload = {
      query: GET_PRESIGNED_URLS_QUERY,
      variables: {
        input: {
          operationType: "GET_PRESIGNED_URLS",
          entityType: "IMAGE",
          fileNames,
        },
      },
    };
    console.log(
      `PMM - SF - api - fetchPresignedUrlsFromApi - apiPayload: ${JSON.stringify(
        apiPayload
      )}`
    );
    const response = await client.query(apiPayload);

    console.log(
      `PMM - SF - imageApi.js - fetchPresignedUrlsfromApi - response is: ${JSON.stringify(
        response
      )}`
    );
    const presignedUrls = response.data.getPresignedUrls.presignedUrls;
    console.log(
      `PMM - SF - imageApi.js - fetchPresignedUrlsfromApi - response is: ${JSON.stringify(
        response
      )}`
    );
    return presignedUrls;
  } catch (error) {
    console.log(
      `PMM - SF - imageApi.js - fetchPresignedUrlsfromApi - catch hit! - error is: ${JSON.stringify(
        error
      )}`
    );
    console.error("Error fetching pre-signed URLs:", error);
    throw error;
  }
};

export const getPresignedGetUrlsFromApi = async (fileNames) => {
  console.log(
    `PMM - SF - api - getPresignedGetUrlsFromApi - fetching URLs for fileNames: ${JSON.stringify(
      fileNames
    )}`
  );

  try {
    const apiPayload = {
      query: GET_PRESIGNED_GET_URLS_QUERY,
      variables: {
        input: {
          operationType: "GET_THUMBNAIL_URLS",
          entityType: "IMAGE",
          fileNames,
          tenantId: "instant-startup-ai",
        },
      },
    };
    console.log(
      `PMM - SF - api - getPresignedGetUrlsFromApi - apiPayload: ${JSON.stringify(
        apiPayload
      )}`
    );
    const response = await client.query(apiPayload);

    // console.log(
    //   `PMM - SF - imageApi.js - fetchPresignedUrlsfromApi - response is: ${JSON.stringify(
    //     response
    //   )}`
    // );
    const presignedUrls = response.data.getPresignedUrls.presignedUrls;
    // console.log(
    //   `PMM - SF - imageApi.js - fetchPresignedUrlsfromApi - response is: ${JSON.stringify(
    //     response
    //   )}`
    // );
    return presignedUrls;
  } catch (error) {
    // console.log(
    //   `PMM - SF - imageApi.js - fetchPresignedUrlsfromApi - catch hit! - error is: ${JSON.stringify(
    //     error
    //   )}`
    // );
    console.error("Error fetching pre-signed URLs:", error);
    throw error;
  }
};
